<div class="c_grid" id="{{ 'courses_div'+ course.id }}"  [ngClass]="{'home-course': pageName == 'home'}">
    <div class="clearfix  c_grid_banner" (click)="details(course)" >
        <img [src]="course.logo_link.replace('https://s3-ap-south-1.amazonaws.com/iquantamedia', 'https://media.iquanta.in')" alt="{{course.course_name.split('.')[1]}}" loading="lazy">
    </div>

    <div class="clearfix c_info px-3 py-2">
        <h4 *ngIf="course.course_name.includes('.')">
            {{course.course_name.split('.')[1]}}
        </h4>
        <h4 *ngIf="!course.course_name.includes('.')">{{course.course_name}}
        </h4>

        <ul>
            <li>
                <p [innerHTML]="course.speciality | safeHtml"></p>
            </li>
        </ul>

        <div >

            <div *ngIf="course.display_only_one">
                <div class="clearfix c_footer d-flex  d-flex p-0">
                    <div class="price_range mr-auto ">
                        <span class="mr-auto">
                            {{course.offer_price|currency}}</span>
    
    
                        <small class="me-auto" style="color: #8f9ca9;"
                            *ngIf="course.actual_price != course.offer_price"><del>
                                {{course.actual_price|currency}}</del></small>
                    </div>
                   <div class="mobile-none">
                    <button class="pushable" (click)="buynow(course)">
                        <div class="front">
                            Course Structure & Discount
                        </div>
                      </button>
                   </div>
                        <!-- <button class="learn-more"  (click)="buynow(course)">Course Structure & Discount</button> -->
                </div>
            </div>

            <div *ngIf="!course.display_only_one">

            <div class="clearfix c_footer  mobile-none ">
                <div class="d-md-flex">
                    <div class="price_range mr-auto ">
                        <span class="mr-auto">
                            {{course.offer_price|currency}}</span>
    
    
                        <small class="me-auto" style="color: #8f9ca9;"
                            *ngIf="course.actual_price != course.offer_price"><del>
                                {{course.actual_price|currency}}</del></small>
                    </div>
                    <div>
                        <button mat-button class="buyNow" style="margin-right: 10px;
                        " (click)="buynow(course)">Buy
                            now</button>
    
                        <button *ngIf="!course.display_only_one" (click)="details(course)" mat-button>Details</button>
                    </div>
                </div>
              

            </div>
            </div>
        </div>

        <div class="desk-none">
            <div *ngIf="course.display_only_one">
                <button class="pushable" (click)="buynow(course)">
                    <div class="front">
                        Course Structure & Discount
                    </div>
                  </button>
            </div>
            <div *ngIf="!course.display_only_one">
            <div class="clearfix c_footer  mobile_view_icons ">

                <span class="" style="margin-right:7px !important;">
                    {{course.offer_price|currency}}</span>


                <span class="me-auto" style="color: #8f9ca9;" *ngIf="course.actual_price != course.offer_price"><del>
                        {{course.actual_price|currency}}</del></span>


                <button mat-icon-button color="primary" (click)="buynow(course)">
                    <mat-icon>add_shopping_cart</mat-icon>
                </button>

                <button *ngIf="!course.display_only_one" (click)="details(course)" mat-icon-button color="primary">
                    <mat-icon>visibility</mat-icon>
                </button>


            </div>
            </div>
        </div>



    </div>

</div>